interface ProgressBarProps {
  /** 0..1, or null for an indeterminate (striped, full-width) bar. */
  value: number | null;
  tone?: 'accent' | 'go';
}

export function ProgressBar({ value, tone = 'accent' }: ProgressBarProps) {
  const pct = value === null ? 100 : Math.max(4, Math.min(100, value * 100));
  const color = tone === 'go' ? 'bg-go' : 'bg-accent';
  return (
    <div
      className="h-8 w-full overflow-hidden rounded-full bg-panel ring-2 ring-line"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value === null ? undefined : Math.round(pct)}
    >
      <div
        className={`progress-stripes h-full rounded-full ${color} transition-[width] duration-700 ease-out ${
          value === null ? 'opacity-60' : ''
        }`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
